import * as React from "react";
import styled from "styled-components";
import { Button, ControlGroup } from "@conserveit/blocks";
import { Foot as Wrapper } from "../ProjectSettings.styles";
import { useConfigState } from "../../../context/settings/config";
import { useActions } from "../../../context/settings/config/useActions";

interface Props {
  activeProject: string;
}

const Group = styled(ControlGroup)`
  justify-content: flex-end;
`;

const Foot: React.FC<Props> = ({ activeProject }) => {
  const state = useConfigState();
  const { resetConfig, saveProjectConfig } = useActions();

  const handleSaveProject = React.useCallback(() => {
    void saveProjectConfig(
      activeProject,
      state.saved,
      state.active,
      state.insightType
    );
  }, [state.active]);

  const handleCancel = React.useCallback(() => {
    if (
      window.confirm("You're about to discard all unsaved changes, continue?")
    ) {
      void resetConfig();
    }
  }, []);

  return (
    <Wrapper>
      <Group>
        {/* Disable Save and Cancel when config is saving or unchanged */}
        <Button
          disabled={state.pristine || state.isSaving}
          onClick={handleCancel}
        >
          Cancel
        </Button>
        <Button
          disabled={state.pristine || state.isSaving}
          onClick={handleSaveProject}
          primary
        >
          Save Changes
        </Button>
      </Group>
    </Wrapper>
  );
};

Foot.propTypes = {};

Foot.defaultProps = {};

export default Foot;
